import React, { Component } from "react";
import LoginImage from "../images/sepandlogo.png";
import Background from "../images/background.jpg";
import { Route } from "react-router-dom";
import MobilePage from "./MobilePage";
import SetPassword from "./SetPassword";
import Validation from "./ValidationCode";
import Password from "./Password";
import Back from "../images/back.svg";
import Loading from "../components/Loading";
import { BaseUrl, Authorization, cube, LogoutFunction } from "../static.js";

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstpage: true,
      serverResponse: false,
    };
  }

  componentDidMount() {
    // console.log("====================================");
    // console.log(window.location.hostname);
    // console.log("====================================");
    if (Authorization().token) {
      let data = {};
      data = Object.assign(data, Authorization());

      fetch(BaseUrl + "checkToken", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.history.push("/Restaurants");
          } else {
            this.setState({ serverResponse: true });
          }
        })
        .catch((err) => {
          this.setState({ serverResponse: false });
        });
    } else {
      this.setState({ serverResponse: true });
    }
  }

  onCorrectPassword() {
    this.props.history.push("/Restaurants");
  }

  onSetPassword() {}

  onForgetPassword() {
    this.props.history.push(this.props.match.path + "/ValidationCode");
  }

  onValidatedCode() {
    this.props.history.push(this.props.match.path + "/SetPassword");
  }

  onValidatedCodeBack() {}

  onSubmitMobile() {
    this.setState({ firstpage: false });
  }

  onMobileLoad() {
    this.setState({ firstpage: true });
  }

  onBack() {
    this.props.history.goBack();
  }

  render() {
    if (this.state.serverResponse) {
      return (
        <div className="Login">
          <img
            src={Background}
            alt=""
            style={{
              position: "absolute",
              left: "0",
              top: "0",
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: "-1",
            }}
          />
          <div className="header">
            {!this.state.firstpage && (
              <div onClick={this.onBack.bind(this)} className="backButton">
                <img
                  src={Back}
                  alt=""
                  className="backButtonIcon"
                  style={{ transform: "rotate(180deg)" }}
                />
                بازگشت
              </div>
            )}
          </div>
          <div className="LoginContent">
            <img src={LoginImage} alt="" className="LoginPicture" />
            <div className="LoginContentPages">
              <Route
                exact
                path={this.props.match.path}
                render={(props) => (
                  <MobilePage
                    {...props}
                    onSubmitMobile={this.onSubmitMobile.bind(this)}
                    onMobileLoad={this.onMobileLoad.bind(this)}
                  />
                )}
              />
              <Route
                path={`${this.props.match.path}/Password`}
                render={(props) => (
                  <Password
                    {...props}
                    onSubmitMobile={this.onSubmitMobile.bind(this)}
                    onCorrectPassword={this.onCorrectPassword.bind(this)}
                    onForgetPassword={this.onForgetPassword.bind(this)}
                    onPasswordBack={this.onValidatedCodeBack.bind(this)}
                  />
                )}
              />
              <Route
                path={`${this.props.match.path}/SetPassword`}
                render={(props) => (
                  <SetPassword
                    {...props}
                    onSubmitMobile={this.onSubmitMobile.bind(this)}
                    onSetPassword={this.onSetPassword.bind(this)}
                  />
                )}
              />
              <Route
                path={`${this.props.match.path}/ValidationCode`}
                render={(props) => (
                  <Validation
                    {...props}
                    onSubmitMobile={this.onSubmitMobile.bind(this)}
                    onValidatedCode={this.onValidatedCode.bind(this)}
                    onValidatedCodeBack={this.onValidatedCodeBack.bind(this)}
                  />
                )}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}
